import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { State } from 'src/app/state/app.state';
import { getImpersonateAssistDetails } from '../lobby-staff-status/state/selectors/lobby-staff-status.selector';
import { ImpersonateAssistDetailModel } from '../lobby-staff-status/shared/models/impersonate-assist-detail.model';
import { ImpersonateTransferPostData } from '../shared/models/impersonate-transfer-data';
import { LobbyEntryService } from '../shared/services/lobby-entry.service';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-transfer-impersonate-assists',
  templateUrl: './transfer-impersonate-assists.component.html',
  styleUrls: ['./transfer-impersonate-assists.component.scss']
})

export class TransferImpersonateAssistsComponent implements OnInit {
  
  impersonateTransferSubs = new Subscription();
  public impersonateAssistDetail: ImpersonateAssistDetailModel | null = null;
  public cloneImpersonateAssistDetail: ImpersonateAssistDetailModel | null = null;
  public transferAllDisable: boolean = false;
  public isFormValid: boolean = false;

  @Input()
  public dialogOpened: boolean = false;
  @Output() public dialogOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public cancelled = new EventEmitter();
  @Output() public hideButton = new EventEmitter();

  constructor(private store: Store<State>,private lobbyEntryService:LobbyEntryService,private toastService:ToastService) { }

  ngOnInit(): void {

    this.impersonateTransferSubs.add(
      this.store.select(getImpersonateAssistDetails).subscribe((assistDetails) => {
        this.impersonateAssistDetail = JSON.parse(JSON.stringify(assistDetails));
        if(this.impersonateAssistDetail != null) {
          this.impersonateAssistDetail.impersonatedByUserId = 0;
          this.transferAllDisable = false;
          this.validateForm();
        }
       
        this.cloneImpersonateAssistDetail = assistDetails; 
     })
     );

  }

  public close() { 
    this.cancelled.emit();
   
  }

  public bulkUserChange(event: Event) {

    const targetElement = event.target as HTMLSelectElement;
    const eventValue = parseInt(targetElement.value);

    var availableCount=this.impersonateAssistDetail?.availableUsers?.find(x => x.userId== eventValue)?.availableImpersonateAssistCount;
      
    this.impersonateAssistDetail?.availableOptions.map((obj) => {
      
      if (obj.availableUsers.filter(x => x.userId==eventValue).length != 0 && availableCount && availableCount > 0) {
        obj.impersonatedByUserId = eventValue;
        availableCount = availableCount - 1;
      
      } else {
        obj.impersonatedByUserId = 0;
      }
      
      return obj;
    });

    this.optionUserChange();
    this.validateForm();

  }

  public optionUserChange() {

    this.transferAllDisable = false;
    var selectedUserId: number[] = [];
    this.impersonateAssistDetail?.availableOptions.forEach((element) => {     
   
      if(element.impersonatedByUserId != this.impersonateAssistDetail?.impersonatedByUserId && element.impersonatedByUserId != 0) {
        
        this.transferAllDisable=true;
      }
      if(element.impersonatedByUserId != 0) {
        selectedUserId.push(element.impersonatedByUserId);
      }
  
     return element;
    });
    
    this.updateAvailableCount(selectedUserId);
    this.transferAllDropDownValue();
    this.validateForm();
    
  }
  
  private updateAvailableCount(selectedUserIds: number[]) {
    this.impersonateAssistDetail?.availableOptions.forEach((element,index) => {
    
      element.availableUsers=JSON.parse(JSON.stringify(this.cloneImpersonateAssistDetail?.availableOptions[index]?.availableUsers));
      element.availableUsers.forEach(user => {
        user.availableImpersonateAssistCount=user.availableImpersonateAssistCount-selectedUserIds?.filter(obj => obj == user.userId).length;
      })

     return element;
    });
  }

  private transferAllDropDownValue() {
    
    var selectedUserIds: any[] = [];
    this.impersonateAssistDetail?.availableOptions.forEach((element) => {

      if (element.impersonatedByUserId != 0) {
        selectedUserIds.push(element.impersonatedByUserId);
      }
    });

    this.transferAllDisable =false;
    
    selectedUserIds.forEach(userId => {
      if (this.impersonateAssistDetail?.impersonatedByUserId != userId && userId > 0) {
        this.transferAllDisable=true;
      }
    });

    if (this.impersonateAssistDetail && this.transferAllDisable==false && selectedUserIds.length != 0) { 

      this.impersonateAssistDetail.impersonatedByUserId=selectedUserIds[0];
    }
    else if (this.impersonateAssistDetail && selectedUserIds.length == 0) {
      this.impersonateAssistDetail.impersonatedByUserId = 0;
    }

  }

  private validateForm() {
    this.isFormValid = true;
    this.impersonateAssistDetail?.availableOptions.forEach((element) => {
      
      if(element.impersonatedByUserId==0) {
        this.isFormValid=false;
      }
    });
  }

  public postImpersonateTransferData() {
    
    if (this.isFormValid) {
      var impersonateTransferPostDataList: ImpersonateTransferPostData[] = [];
      this.impersonateAssistDetail?.availableOptions.forEach((element) => {
        var impersonateTransferPostData: ImpersonateTransferPostData = {
          userSignInSessionId:element.userSignInSessionId,
          transferToUserId:element.impersonatedByUserId
        }
       impersonateTransferPostDataList.push(impersonateTransferPostData);
      });
      
      this.lobbyEntryService.transferImpersonateAssist(impersonateTransferPostDataList).subscribe(() => {

        this.toastService.showSuccess('_Shared_ModelPopUp_Transfer_Assist_Other_Success_Text_');
        this.cancelled.emit();
        this.hideButton.emit();
  
      }, () => {
       
        this.toastService.showError('_Shared_ModelPopUp_Transfer_Assist_Other_Failed_Text_');
        this.cancelled.emit();
  
      });
    }
  }
  
  ngOnDestroy(): void {
    this.impersonateTransferSubs.unsubscribe();
  }

}